<template>
  <ion-header :translucent="true">
    <ion-toolbar>
      <ion-buttons slot="secondary">
        <ion-button @click="closeModal">
          <ion-icon slot="icon-only" :icon="closeOutline"></ion-icon>
        </ion-button>
      </ion-buttons>
      <ion-title>{{ title }}</ion-title>
    </ion-toolbar>
  </ion-header>
  <ion-content v-if="this.profile!=null">
    <div class="profile-banner-pic">
      <img v-if="profile.banner_pic!=null && profile.banner_pic!=''" :src="bannerpath + profile.banner_pic">
    </div>
    <div class="profile-header">
      <ion-grid >
        <ion-row>
          <ion-col size="sm">
            <div v-if="profile.profile_pic!=null && profile.profile_pic!=''" class="profile-header-pic">
              <img @error="imgUrlAlt" :src="profilepath + profile.profile_pic">
            </div>
            <div v-if="profile.profile_pic=='' || profile.profile_pic==undefined" class="profile-header-pic">
              <img class="story-thumb-pic" src="/assets/spyguy.png" >
            </div>
          </ion-col>
          <ion-col>
            <h2 class="profile">{{ profile.first_name }}</h2>
            <span class="username">@{{ profile.user_name }}</span><br /><div class="joined">{{ $t('labels.joined') }} {{ profile.start_year }}</div>
          </ion-col>
        </ion-row>
      </ion-grid>
    </div>
    <h2 class="profile" style="margin:10px;">{{ this.profile.full_name }}</h2>
    <p class="bio" style="white-space: pre-wrap; margin: 10px;">{{ this.profile.premium_info }}</p>
    <p v-if="profile.premium_content==1 && paymenttype=='monthly'" style="white-space: pre-wrap; margin: 10px; font-size: 0.8em;">Subscribe to receive exclusive Premium content.</p>
    <p v-if="profile.premium_content==1 && paymenttype=='one-time'" style="white-space: pre-wrap; margin: 10px; font-size: 0.8em;">Make a one-time payment to support my content.  At this time no additional premium content provided.</p>
    <p v-if="profile.premium_content==0" style="white-space: pre-wrap; margin: 10px; font-size: 0.8em;">Your {{ paymenttype }} payment is used to sponsor my content on {{ getEnv('APP_NAME') }}.</p>
    <div style="padding-bottom:25px;" v-if="(!isPlatform('hybrid') && !isPlatform('electron')) || (isPlatform('hybrid') && !isPlatform('ios'))" >
      <ion-segment v-if="profile.one_time_payment==1 && loadForm==false" v-model="paymenttype">
        <ion-segment-button value="monthly">
          <ion-label>Monthly</ion-label>
        </ion-segment-button>
        <ion-segment-button value="one-time">
          <ion-label>One-Time</ion-label>
        </ion-segment-button>
      </ion-segment>
      <ion-item v-if="profile.fixed_price==0 && paymenttype=='monthly' && profile.is_subscribed==false && loadForm==false">
        <ion-label>Select price: (minimum: ${{ profile.premium_price }}/{{ $t('premium.month') }})</ion-label>
        <ion-select v-model="this.premiumprice" :interface="priceInterface()">
          <ion-select-option v-for="(priceInfo, priceIndex) in priceList" :key="priceIndex" :value="priceInfo.cost">${{ priceInfo.cost }}/{{ $t("premium.month") }}</ion-select-option>
        </ion-select>
      </ion-item>
      <p v-if="paymenttype=='monthly' && profile.is_subscribed==false" class="bio" style="margin: 10px 10px 20px 10px;">{{ $t('premium.price') }}: <strong>${{ premiumprice }}/{{ $t('premium.month') }}</strong> </p>
      <ion-button v-if="loadForm==false && paymenttype=='monthly' && profile.is_subscribed==false" :disabled="isMyProfile" id="button" @click="loadStripeData()" expand="full">Enter Payment Information</ion-button>
      <p v-if="profile.is_subscribed==true && paymenttype=='monthly'" class="bio" style="margin: 10px 10px 20px 10px;">{{ displayStatus() }}</p>
      
      <div v-if="paymenttype=='one-time' && loadForm==false">
        <div class="ion-text-center ion-padding">
          <ion-button @click="onetimepay(25.00)">$25</ion-button><ion-button @click="onetimepay(50.00)">$50</ion-button><ion-button @click="onetimepay(100.00)">$100</ion-button><ion-button @click="onetimepay(200.00)">$200</ion-button><ion-button @click="otheramount=true">Other</ion-button>
        </div>
        <ion-item v-if="otheramount==true">
        <ion-input :clear-input="true" type="number" v-model="premiumprice"></ion-input>
        <div slot="helper">Enter amount</div>
        </ion-item>
      </div>
      <p v-if="paymenttype=='one-time'" class="bio" style="margin: 10px 10px 20px 10px;">{{ $t('premium.price') }}: <strong>${{ Intl.NumberFormat('en-IN').format(premiumprice) }}</strong> </p>
      <ion-button v-if="paymenttype=='one-time' && loadForm==false && premiumprice > 0" id="button" :disabled="isMyProfile" @click="loadStripeData()" expand="full">Enter Payment Information</ion-button>
      <form v-if="loadForm==true" id="payment-form">
        <div v-if="!isMyProfile" style="padding:20px;">
          <div id="payment-element">
            <!-- Elements will create input elements here -->
          </div>
        </div>
        <!-- We'll put the error messages in this element -->
        <ion-button :disabled="isMyProfile" id="button" @click="subscribe" expand="full">{{ displayButton() }}</ion-button>
        <div id="payment-element-errors" style="text-align: center; color: red; padding: 20px;" role="alert"></div>
        <div class="result-message" style="display:none; text-align: center; padding: 20px;" role="alert"></div>
      </form>
    </div>
    <div v-else>
      <div style="white-space: pre-wrap; margin: 10px;" v-show="(isPlatform('hybrid') && isPlatform('ios')) || isPlatform('electron')"><p class="bio"><strong>Get my premium content on the {{ getEnv('SHARE_HOSTNAME') }} website.</strong></p></div>
    </div>
  </ion-content>

</template>

<script>
import { IonContent, IonHeader, IonTitle, IonToolbar, IonButton, IonButtons, IonCol, IonGrid, IonRow, modalController, IonIcon, alertController, loadingController, isPlatform, IonSelect, IonSelectOption, IonLabel, IonItem, IonSegment, IonSegmentButton, IonInput } from '@ionic/vue';
import { closeOutline, people, checkmark, closeCircle  } from 'ionicons/icons';
import { defineComponent } from 'vue';
import { loadStripe } from '@stripe/stripe-js'
import getEnv from '@/utils/env'

export default defineComponent({
  name: 'BuyModal',
  props: {
    title: { type: String, default: '' },
    profile: { type: Object, default: null },
    isMyProfile: { type: Boolean, default: false }
    //user_id: { type: Number, default: 0 },
  },
  setup() {
    const isDisabled = false;
    const closeModal = () => {
      modalController.dismiss(null, 'closed');
    };

    return {
      closeOutline,
      closeModal,
      isDisabled,
      people,
      checkmark,
      closeCircle,
      isPlatform,
      getEnv
    }
  },
  components: { IonContent, IonHeader, IonButton, IonButtons, IonTitle, IonToolbar, IonIcon, IonCol, IonGrid, IonRow, IonSelect, IonSelectOption, IonLabel, IonItem, IonSegment, IonSegmentButton, IonInput },
  async mounted() {
    //await this.$store.dispatch("profile/info");
    /* let notHybrid = (!isPlatform('hybrid') && !isPlatform('electron')) || (isPlatform('hybrid') && !isPlatform('ios'));
     if(notHybrid && !this.isMyProfile){
      if(this.profile.fixed_price==1){
        this.loadStripeData();
      }
    } */
   
    /*
    let profileData = await this.$store.dispatch("profile/otherUserInfo", { userId: this.user_id }) ;
      if(profileData!=null){
        this.profile = this.$store.state.profile.profilePageData[this.user_id];
        if(notHybrid) this.loadStripeData();
      }
    */
    /*if(this.profileData==null && this.user_id!=''){
      let profileData = await this.$store.dispatch("profile/otherUserInfo", { userId: this.user_id }) ;
      if(profileData){
        this.profile = this.$store.state.profile.profilePageData;
        if(notHybrid) this.loadStripeData();
      }
    }else{
      this.profile = this.profileData;
      if(notHybrid) this.loadStripeData();
    }*/
    
    /*if(response['error']!=undefined){
      console.log('Error: ' + response['error']);
    }else{
      console.log('store info');
    }*/
  },
  data() {
    return {
      loadingIndicator: '',
      stripe: {}, // or whatever data type
      webIntent: '',
      bannerstorepath: getEnv('AWS_URL') + getEnv('PREMIUM_BUCKET') +  '/banner/',
      card: null,
      profilepath: getEnv('AWS_URL') + getEnv('PHOTO_BUCKET') + '/profile/',
      bannerpath: getEnv('AWS_URL') + getEnv('PHOTO_BUCKET') + '/banner/',
      premiumprice: this.profile.premium_price,
      paymenttype: 'monthly',
      loadForm: false,
      otheramount: false,
      client_secret: '',
      elements: null
    }
  },
  methods: {
    showCheckout(){

      const options = {
        clientSecret: this.client_secret,
        // Fully customizable with appearance API.
        appearance: {/*...*/},
      };

      this.elements = this.stripe.elements(options);
      let paymentElement = this.elements.create('payment');
      paymentElement.mount('#payment-element');

      /* let fontColor = 'rgb(40,40,40)';
      let placeHolderColor = 'rgb(100,100,100)';
      if (this.$store.state.helpers.darkMode == "true") {
        fontColor = 'rgb(255,255,255)';
        placeHolderColor = 'rgb(190,190,190)';
      }
      var style = {
        base: {
          iconColor: fontColor,
          color: fontColor,
          fontFamily: 'Arial, sans-serif',
          backgroundColor: 'clear',
          fontSmoothing: "antialiased",
          fontSize: "18px",
          "::placeholder": {
            color: placeHolderColor
          }
        },
        invalid: {
          fontFamily: 'Arial, sans-serif',
          color: "#fa755a",
          iconColor: "#fa755a"
        }
      };

      this.card = elements.create('card', {
        style: style
      });
      //this.card = elements.create("card", { style: style });
      // Stripe injects an iframe into the DOM
      this.card.mount("#card-element"); */

      paymentElement.on("change", function (event) {
        // Disable the Pay button if there are no card details in the Element
        document.querySelector("#button").disabled = event.empty;
        document.querySelector("#payment-element-errors").innerHTML = event.error ? event.error.message : "";
      });

      /* var form = document.getElementById("payment-form");
      form.addEventListener("submit", function(event) {
        event.preventDefault();
        // Complete payment when the submit button is clicked
        payWithCard(this.stripe, card, data.clientSecret);
      }); */

      //let elements = this.stripe.elements();
      //let card = elements.create('card');
      //card.mount('#card-element');

      //card.on('change', function (event) {
      //  this.displayCheckoutError(event);
      //});
    },
    term(length){
      var termValue = '';
      if(length==1){
        termValue = "mo.";
      }else if(length==12){
        termValue = "yr.";
      }

      return termValue;
    },
    displayCheckoutError(event) {
      //changeLoadingStatePrices(false);
      let displayError = document.getElementById('payment-element-errors');
      if (event.error) {
        displayError.textContent = event.error.message;
      } else {
        displayError.textContent = '';
      }
    },
    async createIntent(){
      let response = await this.$store.dispatch("premium/checkout",{
        premium_user_id: this.profile.id,
        product_price: this.premiumprice,
        product_length: 1,
        account_upgrade: false,
        payment_type: this.paymenttype
      });

      if(response){
        console.log(response, 'response');
        this.loadingIndicator.dismiss();
        if(response.error != undefined){
          console.log('Error: ' + response.error);
          const alert = await alertController
          .create({
            cssClass: 'my-custom-class',
            header: 'Error Setting Up',
            message: response.error,
            buttons: [
              {
                text: 'Close',
              },
            ],
          });
          alert.present();
          return false;
        }else if(response.receipt==undefined){
            var message = "An error occured when setting up."
            if(response.message!=undefined) message = response.message;
            const alert = await alertController
            .create({
              cssClass: 'my-custom-class',
              header: 'Error Setting Up',
              message: message,
              buttons: [
                {
                  text: 'Close',
                },
              ],
            });
            alert.present();
            return false;
        }else{
          this.client_secret = response.client_secret;
          this.showCheckout();
          //return response;
        }
      }
    },
    async subscribe(){
      // var a = this;
      await this.presentLoading('Processing: ' + this.profile.user_name);      
      //let response = await this.createIntent();

      if(this.client_secret!=''){
        //console.log(this.client_secret, 'response');
        //console.log(this.card);
        //console.log(this.stripe);
        // Calls stripe.confirmCardPayment
        // If the card requires authentication Stripe shows a pop-up modal to
        // prompt the user to enter authentication details without leaving your page.
        var elements = this.elements;
        let confirm = await this.stripe.confirmPayment({
          elements,
          redirect: 'if_required'
        })
        
        if(confirm!=null) {
          console.log(confirm, 'confirmation');
          this.loadingIndicator.dismiss();
            
          if (confirm.error) {
            // Show error to your customer
            console.log('payment error: ' + confirm.error.message);
            const alert = await alertController
              .create({
                cssClass: 'my-custom-class',
                header: 'Error Subscribing',
                message: confirm.error.message,
                buttons: [
                  {
                    text: 'Close',
                  },
                ],
              });
            return alert.present();
            // showError(confirm.error.message);
          } else {
            // The payment succeeded!
            //orderComplete(response, confirm.paymentIntent.id);
            //orderComplete(confirm.paymentIntent.id);
            let title = 'Subscribed';
            let message = 'Thank you for subscribing! You can easily access your subscription content in your newsfeed or by tapping your Profile/Subscriptions tab or by visiting my Profile/Subscriptions tab.';
            if(this.profile.premium_content!=1){
              title = 'Sponsored';
              message = 'Thanks for your sponsorship, it lets me focus on creating great content!';
            }
            if(this.paymenttype=='one-time'){
              title = 'Payment Complete';
              message = 'Your one time payment is complete!';
            }
            const alert = await alertController
              .create({
                cssClass: 'my-custom-class',
                header: title,
                message: message,
                buttons: [
                  {
                    text: 'Close',
                    handler: () => {
                      modalController.dismiss(null, "subscribed");
                    },
                  },
                ],
              });
              return alert.present();
            }
          }
        }
    },
    async loadStripeData(){
      await this.presentLoading('Please wait')      
      await loadStripe(getEnv('STRIPE_KEY')).then ((result) =>
      {
        this.stripe = result;
        this.loadForm = true;
        this.createIntent();
        //this.showCheckoutCard();
        //console.log(result);
        // do stuff with card if you have too...
      });
    },
    priceInterface(){
      let intType = 'popover';
      if(isPlatform('mobile')){
        intType = 'action-sheet';
      }
      return intType;
    },
    displayButton(){
      let buttonLabel = '';
      if(this.profile.premium_content==1){
        if(this.paymenttype=='monthly'){
          buttonLabel = this.$t('buttons.subscribe');
        }else{
          buttonLabel = 'Pay';
        }
      }else{
        if(this.paymenttype=='monthly'){
          buttonLabel = this.$t('buttons.sponsor');
        }else{
          buttonLabel = 'Pay';
        }
      }
      return buttonLabel;
    },
    displayStatus(){
      let display = '';
      if(this.profile.premium_content==1){
        display = 'You subscribe monthly to premium content by ' + this.profile.user_name;
      }else{
        display = 'You sponsor ' + this.profile.user_name + ' monthly';
      }
      return display;      
    },
    onetimepay(amount){
      this.otheramount = false;
      this.premiumprice=amount;
    },
    async presentLoading(message) {
      this.loadingIndicator = await loadingController
        .create({
          cssClass: 'loading-class',
          message: message,
        });
      await this.loadingIndicator.present();
    },
    imgUrlAlt(event) {
      event.target.src = "/assets/spyguy.png";
    }
  },
  computed: {
    priceList(){
      if(this.$store.state.premium.premiumPrices==undefined || this.$store.state.premium.premiumPrices.length==0){
        this.$store.dispatch("premium/priceList");
        return [];
      }else{
        let filterPrices = [];
        for(let i=0; i < this.$store.state.premium.premiumPrices.length; i++){
          if(this.$store.state.premium.premiumPrices[i].cost>=this.profile.premium_price){
            filterPrices.push(this.$store.state.premium.premiumPrices[i]);
          }
        }
        return filterPrices;
      }
    }
  }
  /* created(){
    loadStripe(getEnv('STRIPE_KEY')).then ((result) =>
    {
      this.stripe = result;
      this.showCheckoutCard();
      console.log(result);
      // do stuff with card if you have too...
    }); 
  }, */
});
</script>
